import { render, staticRenderFns } from "./TrackerPermissionsModal.vue?vue&type=template&id=861042a0&scoped=true&"
import script from "./TrackerPermissionsModal.vue?vue&type=script&setup=true&lang=js&"
export * from "./TrackerPermissionsModal.vue?vue&type=script&setup=true&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "861042a0",
  null
  
)

export default component.exports